import React, { useEffect, useState } from 'react';
import LayoffModal from './LayoffModal';
import { useVoidLayoff } from './useLayoff';
import styles from './layoff.module.scss';

const VoidLayoffModal = ({ layoff, onClose }) => {
  const [reason, setReason] = useState('');
  const [tried, setTried] = useState(false);
  const voidLayoff = useVoidLayoff({ onSuccess: onClose });

  useEffect(() => {
    setReason('');
    setTried(false);
  }, [layoff?.hash]);

  const invalid = reason.trim().length < 3;

  const submit = () => {
    setTried(true);
    if (!invalid) {
      voidLayoff.mutate({ hash: layoff.hash, reason: reason.trim() });
    }
  };

  return (
    <LayoffModal
      isOpen={!!layoff}
      title={`Void lay-off notice for ${layoff?.employee?.name ?? ''}?`}
      onClose={onClose}
    >
      <p>
        Use this for a notice sent in error. If the form was already emailed,
        Payroll and HR get a &quot;This notice is void&quot; email. The
        employee and the superintendent who signed are told, and the original
        form is kept for audit.
      </p>
      <label htmlFor='void-reason' className={styles.field_label}>
        Reason (required)
      </label>
      <textarea
        id='void-reason'
        rows={3}
        className={`${styles.textarea} ${tried && invalid ? styles.invalid : ''}`}
        value={reason}
        onChange={(event) => setReason(event.target.value)}
        placeholder='For example: sent to the wrong employee'
      />
      {tried && invalid && (
        <span className={styles.error_text}>
          Enter a reason to void this notice.
        </span>
      )}
      <div className={styles.modal_actions}>
        <button type='button' className='button grey' onClick={onClose}>
          Keep notice
        </button>
        <button
          type='button'
          className='button red'
          onClick={submit}
          disabled={voidLayoff.isLoading}
        >
          {voidLayoff.isLoading ? 'Voiding...' : 'Void notice'}
        </button>
      </div>
    </LayoffModal>
  );
};

export default VoidLayoffModal;
